/** @module path */ /** for typedoc */
export * from './pathNode';
export * from './pathUtils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/path/index.js
// module id = 605
// module chunks = 0